import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const JSM_SLA_SETTINGS_CLIENT_ID: ClientId = client('jsm-sla-settings');
